import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'

import Button from '../../common/Button'

import notFound from '../../../images/zebra2.jpg'

const Wrapper = styled.div`
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-flow: column wrap;
	background: url(${notFound}) repeat;
	width: 100%;

	p {
		font-size: 2em;
		color: ${props => props.theme.main.bg};
	}

	button {
		color: ${props => props.theme.main.bg};
		border-color: ${props => props.theme.main.bg};
	}
`

const NotFound = ({ button }) => (
	<Wrapper>
		<p>Page Not Found.</p>
		<Link to="/" replace>
			<Button click={null}>Go Home</Button>
		</Link>
	</Wrapper>
)

export default NotFound


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/notFound/NotFound.js